import { Badge } from "@jhool-io/fe-components";
import { removeEnumUnderscore } from "../../../utils/helpers";
import { PaymentStatus } from "../types/payments.types";

export const getPaymentStatusTag = (status: PaymentStatus) => {
    let bgColor: string;
    let textColor: string;

    switch (status) {
        case PaymentStatus.COMPLETED:
            textColor = "var(--color-success-text)";
            bgColor = "var(--color-success-bg)";
            break;
        case PaymentStatus.PENDING:
            textColor = "var(--color-warning-text)";
            bgColor = "var(--color-warning-bg";
            break;
        case PaymentStatus.FAILED:
            textColor = "var(--color-danger-text)";
            bgColor = "var(--color-danger-bg)";
            break;
        case PaymentStatus.REFUNDED:
            textColor = "var(--color-info-text)";
            bgColor = "var(--color-info-bg)";
            break;
        case PaymentStatus.VOIDED:
            textColor = "var(--color-danger-text)";
            bgColor = "var(--color-danger-bg)";
            break;
        default:
            textColor = "var(--color-default-text)";
            bgColor = "var(--color-default-bg)";
    }

    return (
        <span>
            <Badge
                bgColor={bgColor}
                textColor={textColor}
                type="custom"
                content={removeEnumUnderscore(status)}
            />
        </span>
    );
};
